export default class StringUtil
{

	static convertToAllLowerCase(str)
	{
		if(str==null || str=="")
			return str;
		
		return str.toLowerCase();
	}

	static convertToFirstLowerCase(str)
	{
		if(str==null || str=="")
			return str;
		
		return str.charAt(0).toLowerCase() + str.substring(1);
	}
	
	static convertToFirstUpperCase(str)
	{
		if(str==null || str=="")
			return str;
		
		return str.charAt(0).toUpperCase() + str.substring(1);

	}

	static convertToEachFirstLowerCase(str)
	{
		if(str==null || str=="")
			return str;

		var result;
		var ss = str.split(".");
		for(var i=0; i<ss.length; i++)
		{
			if(i==0)
				result = StringUtil.convertToFirstLowerCase(ss[i]);
			else
				result += "." + StringUtil.convertToFirstLowerCase(ss[i]);
		}
		
		return result;
	}

	static convertToEachFirstUpperCase(str)
	{
		if(str==null || str=="")
			return str;
		
		var result;
		var ss = str.split(".");
		for(var i=0; i<ss.length; i++)
		{
			if(i==0)
				result = StringUtil.convertToFirstUpperCase(ss[i]);
			else
				result += "." + StringUtil.convertToFirstUpperCase(ss[i]);
		}
		
		return result;
	}

	static convertStyleToReactStyle(str,splitter="-")
	{
		if(str==null || str=="")
			return str;
		
		var result;
		var ss = str.split(splitter);
		for(var i=0; i<ss.length; i++)
		{
			if(i==0)
				result = ss[i];
			else
				result += StringUtil.convertToFirstUpperCase(ss[i]);
		}
		
		return result;
	}

	static trimLeft(input,trimer1 = " ",trimer2 = "　")
	{
		var i = 0;
		var tmp = input.charAt(i);
		while(tmp == trimer1 || tmp == trimer2)
		{
			i++;
			if(i>(input.length-1))
				return "";
			tmp = input.charAt(i);
		}
		return input.substr(i);	
	}
	
	static trimRight(input,trimer1 = " ",trimer2 = "　")
	{
		var i = input.length - 1;
		var tmp = input.charAt(i);
		while(tmp == trimer1 || tmp == trimer2)
		{
			i--;
			if(i<0)
				return "";
			tmp = input.charAt(i);
		}
		return input.substring(0,i+1);
	}
	
	static trimLeftRight(input,trimer1 = " ",trimer2 = "　")
	{
		var result = StringUtil.trimLeft(input);
		result = StringUtil.trimRight(result);
		return result;
	}
	
	static trimThrough(input,replaceChar = "")
	{
		var result = StringUtil.trimLeftRight(input);
		var reg = /\s+/g;
		result = result.replace(reg,replaceChar);
		return result;
	}

	static toColorStyleString(color)
	{
		let str = color.toString(16);
		while(str && str.length<6)
		{
			str = "0"+str;
		}
		return str;
	}

	/**    
	 * replaceAll    
	 * @param source:String 源数据    
	 * @param find:String 替换对象    
	 * @param replacement:Sring 替换内容    
	 * @return String    
	 * **/    
	static replaceAll( source, find, replacement )
	{     
		if(!source)
			return null;
		
		return source.split( find ).join( replacement );     
	}  

	static evalLEString(LEstr)
	{
		//操作符栈
		var opArray = []
		
		//@表示栈底
		opArray[0] = "@";
		var opPtr = 1;
		//操作数栈
		var numArray = [];
		var numPtr = 0;
		
		//计算结果
		var res = "";
		
		var i;
		var j;
		var tempString = "";
		
		//计算 计算完的操作数清空 结果留在栈底以参与后续计算
		function caculate(operater)
		{
			if (operater.toLowerCase() == "or")
			{
				if(numArray[numPtr-1] == "1" || numArray[numPtr-2] == "1")
					res = "1";
				else
					res = "0";
				
			} else if (operater.toLowerCase() == "and") 
			{
				if(numArray[numPtr-1] == "0" || numArray[numPtr-2] == "0")
					res = "0";
				else
					res = "1";
			} 
			
			numArray[numPtr-1] = "";
			numArray[numPtr-2] = res;
			numPtr--;
		}
		
		//表达式
		for (i=0; i<LEstr.length; i++)
		{
			//使用选择语句代替算符优先级表
			switch (LEstr.charAt(i)) 
			{
				//左括号直接入运算符栈
				case "(" :
					opArray[opPtr] = LEstr.charAt(i);
					opPtr++;
					break;
				//右括号退栈计算，直到遇见一个左括号，以算出括号内的表达式
				case ")" :
					for (j=opPtr-1; j>0; j--)
					{
						if (opArray[j] != "(")
						{
							caculate(opArray[j]);
							//栈顶下一个元素为# 指针按照一般约定在栈顶下一个元素
							opArray[j] = "#";
						} else 
						{
							opArray[j] = "#";
							break;
						}
					}
					opPtr = j;
					break;
				case "a" :
				case "A" :
					//跳过运算符
					i=i+2;
					//如果原栈顶也为and 则先计算原来的and再将新运算符入栈 同样的运算符从左到右依次计算 否则将and入栈 下次扫描到or会先运算  
					if (opArray[opPtr-1] == "and")
					{
						opPtr--;
						caculate(opArray[opPtr]);
						opArray[opPtr] = "#";
					}
					opArray[opPtr] = "and";
					opPtr++;
					break;
				
				case "o" :
				case "O" :
					i=i+1;
					//or为低优先级 如果栈顶的运算符不是左括号也不是栈底，无论是or还是and 都先退栈计算
					if (opArray[opPtr-1] != "(" && opArray[opPtr-1] != "@")
					{
						opPtr--;
						caculate(opArray[opPtr]);
						opArray[opPtr] = "#";
					}
					opArray[opPtr] = "or";
					opPtr++;
					break;
				default :
					//运算数进栈
					var num:String = LEstr.charAt(i);
					if(num == "0" || num == "1")
					{
						numArray[numPtr] = num;
						numPtr++;
					}
					else
					{
						throw new Error("非法操作数");
					}
			}
		}
		
		
		for (j=opPtr-1; j>0; j--) 
		{
			if (opArray[j] != "@") 
			{
				caculate(opArray[j]);
				opArray[j] = "#";
				
			} else 
			{
				break;
			}
		}
		
		return numArray[0]=="1"?true:false;
	}
		
}


// WEBPACK FOOTER //
// ./src/utils/StringUtil.js